export default __webpack_public_path__ + "static/media/ico_warning_orange.fcf94a59.svg";